import { Divider, Typography } from 'antd'
import React from 'react'
import GSM_Outward from '../../../components/GSuperMarket/GSM_Outward/GSM_Outward'

const GSM_OutwardPage = ({userData}) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          Bin Outward
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <GSM_Outward userData={userData} />
    </>
  )
}

export default GSM_OutwardPage